import { Component, OnInit, Input, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { PropertyDocument, EditPropertyDeatilsModel } from '../../../shared/models/SavePropertyInputModel';
import { FormGroup, FormControl, Validators, DefaultValueAccessor } from '@angular/forms';
import { ToastService } from '../../../shared/providers/toast.service';
import { IPropertyDetails, PropertyDocuments } from '../../../shared/models/propertydetails';
import { PropertyListingService } from '../../../shared/providers/property-listing.service';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { environment } from '../../../../environments/environment';
import { DataTablesResponse } from '../../../shared/models/datatables-response';
import { HttpClient } from '@angular/common/http';
import { ValidationService } from '../../../shared/providers/validation.service';
import { DataTableDirective } from 'angular-datatables';
import { Router } from '@angular/router';
import { AuthService } from '../../../shared/auth/auth.service';
import { Subscription } from 'rxjs';
import { DashboardService } from '../../../shared/providers/dashboard.service';
import { DashboardTabs } from '../../property-view.component';

@Component({
  selector: 'app-property-dashboard-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.css']
})
export class FileComponent implements OnInit {
  modalRef: BsModalRef;
  modalRefFile: BsModalRef;
  @Input() propertyId: number = 0;
  @Input() BackgroundFileStoring: number = 0;
  subscription: Subscription = new Subscription();
  modalRefEdit: BsModalRef;
  dashboardTabs = DashboardTabs;
  modalRefDelete: BsModalRef;
  user: any;
  documentPreview: BsModalRef;
  docPreview: any;
  propertyDocuments: PropertyDocuments[] = [];
  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  @Input() property = {} as IPropertyDetails;
  model: EditPropertyDeatilsModel;
  ddapproval: any = false;
  caApproval: any = false;
  omapproval: any = false;
  ddCaApproval: any = false;
  DDColumns = [];
  categoryids = [];
  dtoptions = {};
  IsLoading = false;
  categoryLst = [];
  categoryList = [];
  isFromPropertyDashboard: boolean;
  dueDiligenceDocList: any[] = [];
  public propertyGuid: string;
  fileTypes = '.PDF, .XLSX, .XLS, .DOCX, .DOC, .TXT, .DWG'
  //defaultCategoryText: IMultiSelectTexts = {
  //  defaultTitle: 'Filter By Category',
  //};
  defaultTypeSettings = {
    singleSelection: false,
    text: "Filter By Category",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  };
  protected readonly BASE_URL: string = environment.base_url;
  constructor(private _toastService: ToastService, private router: Router, private http: HttpClient, public Validation: ValidationService,
    private _propertyDetails: PropertyManagementService, private loader: LoaderService, private modalService: BsModalService, public _authenticationService: AuthenticationService, private _auth0: AuthService, private _dashboardService: DashboardService ) { }
  ngOnInit() {
    this.user = this._authenticationService.user;
    this.propertyGuid = this.property != null && this.property != undefined ? this.property.Guid : '';
    this.loadCategoryTypes();
    this.loadDDCategoryTypes(this.propertyId);
    this.checkDDApproval();
    this.checkCAApproval(1);
    this.checkCAApproval(2);
    this.checkOMApproval();
    this.loadPropertyFiles(this.propertyId);

    let imageData = JSON.parse(localStorage.getItem('UploadedImageList'));
    if (imageData != null && imageData != undefined) {
      let ongoingList = imageData.filter(f => f.ImageStatus == '' || f.ImageStatus == null && f.sourceUrl == this.router.url && f.RefreshTab == 'Property-Files');
      if (ongoingList != null && ongoingList.length > 0) {
        localStorage.setItem('currentFileRefreshTab', 'Property-Files');
      }
      else if (localStorage.getItem('currentFileRefreshTab') != undefined && localStorage.getItem('currentFileRefreshTab') != null) {
        localStorage.removeItem('currentFileRefreshTab');
      }
    }

    this.subscription.add(this._auth0
      .customObservable.subscribe((res) => {
      if (res.sourceUrl == this.router.url && localStorage.getItem('currentFileRefreshTab') == 'Property-Files' && res.refreshTab == 'Property-Files') {
        this.dtElement.dtInstance.then(x => x.draw(false));
      }
    }
    ));

  }
  getDocuments() {
    this._propertyDetails.getPropertyDocuments(this.propertyId).subscribe(responds => {
      this.propertyDocuments = responds;
      this.loader.display(false);
    });
  }
  checkDDApproval() {
    this._propertyDetails.checkDDApproval(this.propertyId).subscribe(responds => {
      this.ddapproval = responds;
      this.loader.display(false);
    });
  }
  refreshFiles($event) {
   //// this.getDocuments();
    this.redrawTable();
    this.loadDDCategoryTypes(this.propertyId);
    this.loadCategoryTypes();
  }
  docId = 0;
  onRemoveDocument() {
    var input = [];
    input.push(this.docId);
    this._propertyDetails.deletePropertyDocument(this.docId,this.user.Id, this.property.Id).subscribe(response => {
      this._toastService.addToast({
        title: 'Delete',
        msg: `Deleted Successfully`,
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });
      this.modalRefDelete.hide();
      ////this.getDocuments();
      this.redrawTable()
      this.loadDDCategoryTypes(this.propertyId);
      this.loadCategoryTypes();
    });
  }

  openDeleteModal(template: TemplateRef<any>, classes: any, id: number) {
    this.docId = id;
    this.modalRefDelete = this.modalService.show(template, { class: classes });
  }

  showHideInDD(document: PropertyDocuments) {
    this._propertyDetails.ShowHideDD(document.Id, document.IncludeInDD).subscribe(response => {
      if (response) {
        this._toastService.addToast({
          title: 'Status Changed',
          msg: document.IncludeInDD ? 'Document added to Due Diligence' : 'Document removed from Due Diligence',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });
      }
      else {
        this._toastService.addToast
          ({
            title: 'Status Changed Error',
            msg: "Error Occured",
            timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          });
      }
    });
  }

  previews(template: TemplateRef<any>, classes, document) {
    this.docPreview = document;
    this.documentPreview = this.modalService.show(template, { class: classes });
  }

  saveDueDiligenceApproval(ddapproval) {
    this._propertyDetails.saveDueDiligenceApproval(this.propertyId, ddapproval).subscribe(responds => {
      if (responds) {
        this._toastService.addToast({
          title: 'Status Changed',
          msg: ddapproval ? 'Due Diligence Approval Added' : 'Due Diligence Approval Removed',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });
        let currentRedirectUrl = this.setLink();
        this.router.navigateByUrl(currentRedirectUrl);
      }
      else {
        this._toastService.addToast
          ({
            title: 'Due Diligence Approval Error',
            msg: "Error Occured",
            timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          });
      }
    });
  }

  loadPropertyFiles(propertyid) {
    this.DDColumns = [
      { data: 'Name', orderable: false },
      { data: 'Name', orderable: false },
      { data: 'Name', orderable: false},
      { data: 'Document Title', orderable: false },
      { data: 'Category' },
      { data: 'Uploaded By', orderable: false},
      { data: 'Date' },
     ]


    const that = this;

    this.dtoptions = {
      pagingType: 'full_numbers',
      "pageLength": 20,
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "order": [[6, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        dataTablesParameters.Extra_param = {
          DocumentCategories: that.categoryids,
          IsDataEntryProperty: false
        }

        that.http.post<DataTablesResponse>(
          this.BASE_URL + '/property/documents/' + propertyid, dataTablesParameters).subscribe(resp => {
            if (resp != null) {
              this.propertyDocuments = resp.data ? resp.data : [];
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;
          });
      },
      columns: that.DDColumns
    };
  }

  redrawTable() {
    this.dtElement.dtInstance.then(x => x.draw(false));
  }

  categoryId: number;
  UpdateDocCategory() {
    this._dashboardService.saveBOEPropertyDocumentCategory(this.editFileId, this.categoryId, true, this.user.Id).subscribe(res => {
      this.modalRefEdit.hide();
      this.dtElement.dtInstance.then(x => x.draw(false));
      this._toastService.addToast({ title: 'Success', msg: 'Document category updated successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
    })
  }

  onSearch(text: string) {
    ;
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  editFileId: number;

  openEditModal(template: TemplateRef<any>, classes: any, id: number, category: number) {
    this.categoryId = category;
    this.editFileId = id;
    this.modalRefEdit = this.modalService.show(template, { class: classes });
  }

  loadDDCategoryTypes(propertyid) {
    this.isFromPropertyDashboard = true;
    this._propertyDetails.getDocumentCategoryIds(propertyid, this.isFromPropertyDashboard).subscribe(response => {
      this.categoryLst = response.map(o => {
        return {
          id: o.CategoryId, name: o.Category
        };
      });
    });
  }

  loadCategoryTypes() {
    this._propertyDetails.getFileCategories(6805).subscribe(response => {
      this.categoryList = response.map(o => {
        return { id: o.Id, name: o.Description };
      });
    });
  }

  OpenAddFileSlider(template: TemplateRef<any>, classes: any) {
    this.modalRefFile = this.modalService.show(template, { class: classes });
  }

  saveOMApproval(omapproval) {
    this._propertyDetails.saveOMAPproval(this.propertyId, omapproval).subscribe(responds => {
      if (responds) {
        this._toastService.addToast({
          title: 'Status Changed',
          msg: omapproval ? 'Offering Memorandum Approval Added' : 'Offering Memorandum Approval Removed',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });
        let currentRedirectUrl = this.setLink();
        this.router.navigateByUrl(currentRedirectUrl);
      }
      else {
        this._toastService.addToast
          ({
            title: 'Offering Memorandum Approval Error',
            msg: "Error Occured",
            timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          });
      }
    });
  }

  saveCAApproval(caApproval,typeId) {
    this._propertyDetails.saveCAAPproval(this.property.Id, caApproval, typeId).subscribe(responds => {
      if (responds) {
        this._toastService.addToast({
          title: 'Status Changed',
          msg: caApproval ? 'Confidentiality Agreement Approval Added' : 'Confidentiality Agreement Approval Removed',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });
        let currentRedirectUrl = this.setLink();
        this.router.navigateByUrl(currentRedirectUrl);

      }
      else {
        this._toastService.addToast
          ({
            title: 'Confidentiality Agreement Approval Error',
            msg: "Error Occured",
            timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          });
      }
    });
  }

  checkOMApproval() {
    this._propertyDetails.checkOMApproval(this.propertyId).subscribe(responds => {
      this.omapproval = responds;
    });
  }

  checkCAApproval(typeId) {
    this._propertyDetails.checkCAApproval(this.property.Id, typeId).subscribe(responds => {
      if (typeId == 1) {
        this.caApproval = responds;
      }
      else {
        this.ddCaApproval = responds;
      }
    });
  }


  setLink() {
    localStorage.setItem('property-dashboard-Tab', this.dashboardTabs.Files.toString());
    return this.router.url;
  }
}
